module.exports = __webpack_public_path__ + "static/media/Montserrat-MediumItalic.66313809.ttf";